<fr-table [config]="tableConfig" [data]="performanceProfiles" Id="performanceprofiles-table"
  [paginatorConfig]="paginatorConfig">
  <div above-table-body-space>
    <app-loading-spinner *ngIf="!performanceProfiles"></app-loading-spinner>
  </div>
</fr-table>